var fireEvent;

(function (jQuery) {
	jQuery(document).ready(function () { //when DOM is ready
		c2m.init();
	});
	jQuery(window).resize(function () {
		clearTimeout(fireEvent);
		fireEvent = setTimeout(c2m.resizeEvent, 200);
	});
})(jQuery);
jQuery(window).load(function () {
//	c2m.initDropdownMenuWidth();
});

var c2m = {
	init: function () {
		c2m.initProductPopupForm();
		c2m.initRelatedProductsTab();
		c2m.initProductImageLightbox();
	},
	initProductPopupForm: function() {
		var wrapper = jQuery('.c2m-ask-popup');
		
		if (wrapper.length > 0) {
			var open_on_pageload = wrapper.find('.contact-us-form').data('popup-open');
			var trigger = jQuery('.c2m-ask-popup-trigger');
        	var form = wrapper.find('form');
			var textarea = wrapper.find('.contact-us-form textarea[name="contact[body]"]');
			var dscr_ready = false;
			
			function openPopup() {
				trigger.addClass('active');
				jQuery('.focus').addClass('out-of-focus');
				
				if(window.innerWidth < 1367)
				{
					wrapper.css({top: jQuery(window).scrollTop()+ 64});
				}
				
				wrapper.addClass('open');
			};
			
			function closePopup() {
				trigger.removeClass('active');
				jQuery('.focus').removeClass('out-of-focus');
				wrapper.removeClass('open');
			};
			
			if(open_on_pageload) {
				openPopup();
			}
			
			trigger.on('click', function (e) {
				openPopup();
				e.preventDefault();
			});
			
			wrapper.find('.close').on('click', function (e) {
				closePopup();
				e.preventDefault();
			});
			
			// count characters entered in textarea
			jQuery(textarea).on('keyup', function() {
				var min = 10,
				len = this.value.length;
				
				if(len < min) {
					change_dscr_state(false);
				} else {
					change_dscr_state(true);
				}
			});
			
			function change_dscr_state(state){
				dscr_ready = state;
			}
			
			wrapper.find('#c2m-send-question').on('click', function (e) {
				e.preventDefault();
				form.submit();
			});
			
			// form validation on form submit event
			form.submit(function(e) {
				e.preventDefault();
				
				if(dscr_ready) {
					this.submit();
				} else {
					textarea.addClass('not-enough-chars');
					setTimeout(function() {
						textarea.removeClass('not-enough-chars');
					}, 500);
				}
			});
			
			
			if(window.innerWidth < 768)
			{
				jQuery('.focus').click(function(e){
					var target = jQuery(e.target);
					if(jQuery(this).hasClass('out-of-focus') && !target.is(trigger)) {
						closePopup();
					}
				});
			}
			
		}
	},
	initHomeCollectionItemHeight: function (wrapper) {
		//2 items in a row
		var items = wrapper.find('.col-md-6 .item-single .details');
		theme.resizeRowItemHeight(items, 2);
	},
	resizeCollectionSlider: function (slider_item) {
		if( window.innerWidth < 768 ) {
			theme.resizeSquareProductImageCollection(slider_item.find('.item-single .image'));
			theme.resizeSquareProductImageCollection(slider_item.find('.item-single .image-slides'));
		} else {
			slider_item.find('.item-single .image').each(function () {
				jQuery(this).height('');
			});
			slider_item.find('.item-single .image-slides').each(function () {
				jQuery(this).height('');
			});
		}
		theme.initHomeCollectionItemHeight(slider_item);
	},
	resizeRelatedProducts: function(slider_item) {
		//adjust height of slider images and wrappers of images
		theme.resizeSquareProductImageCollection(slider_item.find('.image'));
		theme.resizeSquareProductImageCollection(slider_item.find('.image-slides'));

		//adjust height of details block
		c2m.initHomeCollectionItemHeight(slider_item);
	},
	initRelatedProductsTab: function () {
		var slider_item = jQuery('body.template-product #c2m-related-products');

		// related products initial load
		slider_item.find('.image-slides .image').each(function () {
			var img_url = jQuery(this).attr('data-img');
			jQuery(this).css('background-image', 'url(' + img_url + ')');
		});

		var slide_wrap = slider_item.find('.image-slides');
		slide_wrap.cycle({log: false});

		slider_item.addClass('loaded');

		c2m.resizeRelatedProducts(slider_item);
	},
	initRelatedProductsResize: function() {
		var slider_item = jQuery('body.template-product #c2m-related-products');
		c2m.resizeRelatedProducts(slider_item);
	},
	initProductImageLightbox: function () {
		// Product page - image lightbox popup slider
		// --------------------------------------------------
		if(!jQuery('body').hasClass('template-product')) { return false; }
		
		var lb = jQuery('.c2m-image-lightbox-slider');
		var focus = jQuery('.focus');
		var open = jQuery('.c2m-open-lightbox, body.template-product .image-col-wrapper .image-slides');
		var close = jQuery('.c2m-lightbox-close, body.template-product .image-col-wrapper .image-slides .image img');
		var images = open.find('.image:not(.cycle-sentinel)');
				
		open.click(function () {
			if (window.innerWidth < 768) return false;
			
			focus.addClass('out-of-focus');
			var loader = '<div class="quickview-loader"><i class="fa fa-repeat fa-spin"></i></div>';
			jQuery('body').prepend(loader);

			var active_slide_index;
			if(images.length > 1){
				active_slide_index = images.index(open.find('.image.active:not(.cycle-sentinel)'));
			} else {
				active_slide_index = 0;
				lb.addClass('single-image');
			}
						
			if(!lb.hasClass('loaded')) {
				var image_links = [];
				images.each(function(){
					image_links.push(jQuery(this).attr('data-lightbox'));
				});			

				var promises = [];
				for (var i = 0; i < image_links.length; i++) {
					(function(url, promise) {
						var img = new Image();
						img.onload = function() {
						  promise.resolve();
						};
						img.src = url;
					})(image_links[i], promises[i] = jQuery.Deferred());
				}

				jQuery.when.apply(jQuery, promises).done(function() {
					var indicators_html = '';
					var slides_html = '';

					for(var i = 0; i < image_links.length; i++) {
						if(active_slide_index === i) {
							indicators_html += '<a href="#" class="blt-1 active"></a>';
						} else {
							indicators_html += '<a href="#" class="blt-1"></a>';
						}
						slides_html += '<div class="image"><img src="'+ image_links[i] +'"></div>';
					}

					var slider_content_html =	'<div class="image-slides cycle-slideshow" ' +
													'data-cycle-swipe="true" ' +
													'data-cycle-swipe-fx="scrollHorz" ' +
													'data-index="1" ' +
													'data-cycle-log="false" ' +
													'data-cycle-fx="scrollHorz" ' +
													'data-cycle-timeout="0" ' +
													'data-cycle-speed="200" ' +
													'data-cycle-pager="#c2m-image-lightbox-slider-pager" ' +
													'data-cycle-pager-active-class="active" ' +
													'data-starting-slide="'+ active_slide_index +'" ' +
													'data-cycle-pager-template="" ' +
													'data-cycle-prev=".c2m-image-lightbox-slider_prev" ' +
													'data-cycle-next=".c2m-image-lightbox-slider_next" ' +
													'data-cycle-slides=".image">' +
														slides_html +
												'</div>';

					slider_content_html +=	'<a href="#" class="controls prev btn-symbol-1 c2m-image-lightbox-slider_prev"><i class="fa fa-caret-left"></i></a>' +
											'<a href="#" class="controls next btn-symbol-1 c2m-image-lightbox-slider_next"><i class="fa fa-caret-right"></i></a>';

					slider_content_html += '<div class="bullets" id="c2m-image-lightbox-slider-pager">' + indicators_html + '</div>';


					lb.children('div').append(slider_content_html);
					
					lb.find('.cycle-slideshow').on( 'cycle-initialized', function() {
						lb.addClass('loaded');

						jQuery('.quickview-loader').remove();

						lb.show(function () {
							jQuery(this).addClass('open');
							close.addClass('show');
						});
						
					
						lb.find('.cycle-slideshow img').click(function(){
							lb.hide(function () {
								jQuery(this).removeClass('open');
								close.removeClass('show');
								focus.removeClass('out-of-focus');
							});
						});	
					});
					
					lb.find('.cycle-slideshow').cycle();
					
					
					
					
				});
			} else {
				lb.find('.cycle-slideshow').cycle('goto', active_slide_index);
				
				jQuery('.quickview-loader').remove();
					
				lb.show(function () {
					jQuery(this).addClass('open');
					close.addClass('show');
				});
			}
			
			return false;
		});

		close.click(function () {
			lb.hide(function () {
				jQuery(this).removeClass('open');
				close.removeClass('show');
				focus.removeClass('out-of-focus');
			});
			return false;
		});
	},
	resizeEvent: function() {
		c2m.initRelatedProductsResize();
	}
};
